import React from 'react';

import GooglePrivacyBlurb from '@/components/commons/google_privacy_blurb';

import OnboardingPanelTitle from './OnboardingPanelTitle';

interface Props {
    readonly className?: string;
    readonly google?: boolean;
    readonly children: any;
    readonly step?: number;
    readonly image?: string;
    readonly paddingOverride?: string;
    readonly stepNames?: object;
    readonly totalSteps?: number;
    readonly isModal?: boolean;
}

function PanelContainer({
    className = '',
    image = null,
    google = false,
    step = null,
    children,
    paddingOverride = null,
    stepNames = null,
    totalSteps = 3,
    isModal = false,
}: Props) {
    return (
        <div className={`max-w-[1200px] mx-auto mb-4 w-full ${className}`}>
            {!isModal ? (
                <OnboardingPanelTitle
                    currentStep={step}
                    totalSteps={totalSteps}
                    stepNames={stepNames}
                />
            ) : ''}
            <div className={!isModal ? 'bg-cirrusWhite rounded-lg shadow-lg overflow-hidden flex p-0 sm:p-[20px]' : 'flex'}>
                <div
                    className={`hidden sm:none ${!image ? '' : 'md:block'} bg-gray-300 min-h-[730px]
                min-w-[300px] w-[300px] bg-cover bg-no-repeat bg-center`}
                    style={{ backgroundImage: `url(${image})` }}
                />
                <div className={`${paddingOverride || 'flex p-4 sm:p-6'} w-full font-medium relative`}>
                    <div className="flex flex-wrap content-between">
                        {children}
                        {google && <GooglePrivacyBlurb />}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PanelContainer;
